import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
export { default as extend } from './extend';

// The forum attributes set via extend.php's Extend\Settings.
const DISABLE_SPOILER = 'hliEditorButtonsDisableSpoiler';
const DISABLE_IMAGE = 'hliEditorButtonsDisableImage';
app.initializers.add('hli-editor-buttons', () => {
  // flarum/markdown registers this extend point on TextEditor (it isn't
  // declared by flarum/core itself), populating it with the spoiler,
  // image, bold, italic, etc. buttons for the classic markdown editor.
  // Using the string-path form avoids depending on flarum/markdown's own
  // TypeScript types.
  extend('flarum/common/components/TextEditor', 'markdownToolbarItems', function (items) {
    if (app.forum.attribute(DISABLE_SPOILER)) items.remove('spoiler');
    if (app.forum.attribute(DISABLE_IMAGE)) items.remove('image');
  });

  // fof/rich-text replaces the whole toolbar with its own TiptapMenu
  // component (per-user opt-in, chunk-loaded) when installed. It isn't a
  // required dependency of this extension: extend() on the 'ext:...'
  // string path just never fires if fof/rich-text isn't present, so this
  // is a no-op then. Its button keys differ from flarum/markdown's —
  // notably spoiler is split into an inline mark (main toolbar) and a
  // block wrap (in the "additional items" overflow dropdown) — so each
  // needs its own key, unlike 'image' which happens to match.
  extend('ext:fof/rich-text/common/components/TiptapMenu', 'items', function (items) {
    if (app.forum.attribute(DISABLE_SPOILER)) items.remove('spoiler_inline');
    if (app.forum.attribute(DISABLE_IMAGE)) items.remove('image');
  });
  extend('ext:fof/rich-text/common/components/TiptapMenu', 'hiddenItems', function (items) {
    if (app.forum.attribute(DISABLE_SPOILER)) items.remove('spoiler_block');
  });
});